import Vue from 'vue';
import ElementUI from 'element-ui';
import App from './App.vue';
import Echarts from 'echarts';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css'; //登录页面图标使用
import 'babel-polyfill';
import store from './store';
import router from './router';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: 'small',
});
Vue.prototype.$echarts = Echarts;

// Vue.prototype.$api = api;

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | 睡觉吧`;
  const role = localStorage.getItem('ms_username');
  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    role === 'admin' ? next() : next('/403');
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
